import ShowAdornment from './ShowAdornment';

export default ShowAdornment;
